import { BellOutlined } from '@ant-design/icons';
import { Badge, Col, Modal, Popover, Row, Typography } from 'antd';
import classNames from 'classnames/bind';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link, useNavigate } from 'react-router-dom';
import notificationAPI from '~/api/NotificationAPI';
import settingAPI from '~/api/SettingAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import LogOutModal from '~/components/form-log-out';
import Notification from '~/components/Notification';
import config from '~/config';
import { navItems, navItemsMobile, navPopoverProfile } from '~/constants';
import { cartItemsCountSelector } from '~/pages/Cart/selector';
import { handleLogout } from '~/store/actions/UserAction';
import { checkNewNoti } from '~/utils/checkNewNoti';
import styles from './Header.module.scss';

const cx = classNames.bind(styles);

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');

    const cartItemsCount = useSelector(cartItemsCountSelector);

    const [isShowLogoutModal, setIsShowLogoutModal] = useState(false);
    const onCancel = () => {
        setIsShowLogoutModal(false);
    };
    const handleShowLogOut = () => {
        setIsShowLogoutModal(true);
    };
    const [loading, setIsLoading] = useState(false);
    const [notiList, setNotiList] = useState([]);
    //Dot Noti
    const [isNewNoti, setIsNewNoti] = useState(false);
    const [countUnSeen, setCountUnSeen] = useState(0);
    const [countNoti, setCountNoti] = useState(0);

    const [paginationNoti, setPaginationNoti] = useState({
        page: 1,
        limit: 25,
        total_item: 0,
        total_page: 0,
    });
    // const handleChangePage = (page) => {
    //     setPaginationNoti({ ...paginationNoti, page });
    // };
    const fetchNotification = async (step = null) => {
        setIsLoading(true);
        let newLimit = paginationNoti.limit;
        if (step) {
            newLimit = paginationNoti.limit + step;
        }
        const params = {
            fields: '["$all", {"order":["$all"]}]',
            order: '[["created_at","desc"]]',
            page: paginationNoti.page,
            limit: newLimit,
        };
        try {
            const res = await notificationAPI.getList(params);
            const resArr = res.results?.objects?.rows;
            // const isNotSeen = resArr.some((item) => item.seen === false);
            // setIsNewNoti(isNotSeen);
            setCountUnSeen(res.results?.objects?.countUnSeen);
            setPaginationNoti({
                ...paginationNoti,
                limit: newLimit,
                page: res.pagination.current_page,
                total_item: res.results.objects.count,
                total_page: Math.ceil(res.results.objects.count / paginationNoti.limit),
            });
            setCountNoti(res.results?.objects?.count);

            setNotiList(resArr);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            // console.log(err);
        }
    };

    const seenAllNoti = async () => {
        setIsLoading(true);
        try {
            const res = await notificationAPI.seenAll();
            setIsLoading(false);
            fetchNotification();
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };

    const onLogOut = () => {
        try {
            dispatch(handleLogout());
            setIsShowLogoutModal(false);
            navigate(config.routes.home);
        } catch (err) {
            // console.log(err);
        }
    };

    const handleChangePopover = (item, index) => {
        if (item.id < 8) {
            navigate(item.path);
        } else {
            handleShowLogOut();
        }
    };

    useEffect(() => {
        const newNoti = checkNewNoti(notiList);
        if (!newNoti) {
            setIsNewNoti(newNoti);
        }
    }, [notiList]);

    const contentAccount = (
        <>
            {navPopoverProfile?.map((item, index) => {
                return (
                    <Row
                        key={index}
                        className={cx('item_normal')}
                        align="middle"
                        onClick={() => handleChangePopover(item, index)}
                    >
                        <Col>
                            <img src={item.icon} alt="" />
                            <span className={cx('text')}>{item.text}</span>
                        </Col>
                    </Row>
                );
            })}
        </>
    );
    const contentNavbar = (
        <>
            {isLogin &&
                navItems?.map((item, index) => {
                    return (
                        <Row
                            key={index}
                            className={cx('item_normal')}
                            align="middle"
                            onClick={() => navigate(item.path)}
                        >
                            <span className={cx('text')}>{item.title}</span>

                            {/* {item.id !== 4 ? (
                                <Row
                                    key={index}
                                    className={cx('item_normal')}
                                    align="middle"
                                    onClick={() => navigate(item.path)}
                                >
                                    <span className={cx('text')}>{item.title}</span>
                                </Row>
                            ) : (
                                <Row key={index} className={cx('item_normal')} align="middle">
                                    <a href={item.path} target="blank">
                                        <span className={cx('text')}>{item.title}</span>
                                    </a>
                                </Row>
                            )} */}
                        </Row>
                    );
                })}
            {!isLogin &&
                navItemsMobile?.map((item, index) => {
                    return (
                        <Row
                            key={index}
                            className={cx('item_normal')}
                            align="middle"
                            onClick={() => navigate(item.path)}
                        >
                            <span className={cx('text')}>{item.title}</span>
                            {/* {item.id !== 4 ? (
                                <Row
                                    key={index}
                                    className={cx('item_normal')}
                                    align="middle"
                                    onClick={() => navigate(item.path)}
                                >
                                    <span className={cx('text')}>{item.title}</span>
                                </Row>
                            ) : (
                                <Row key={index} className={cx('item_normal')} align="middle">
                                    <a href={item.path} target="blank">
                                        <span className={cx('text')}>{item.title}</span>
                                    </a>
                                </Row>
                            )} */}
                        </Row>
                    );
                })}
        </>
    );

    const [listInfo, setListInfo] = useState([]);

    const handleGetListInfo = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            let final = [];
            const res = await settingAPI.getListInfo(params);
            if (res.code === 200) {
                const rows = res.results.object;
                for (let i = 0; i < rows.length; i++) {
                    if (rows[i].type === 'WORK_TIME') {
                        final[0] = { ...rows[i] };
                    }
                    if (rows[i].type === 'HOTLINE') {
                        final[1] = { ...rows[i] };
                    }
                }
            }
            setListInfo(final);
        } catch (err) {
            // console.log(err);
        }
    };

    const handleClickCart = () => {
        navigate(config.routes.cart);
        // if (isLogin) {
        //     navigate(config.routes.cart);
        // } else {
        //     navigate(config.routes.login);
        // }
    };

    useEffect(() => {
        if (isLogin) {
            fetchNotification();
        }
        handleGetListInfo();
        //eslint-disable-next-line
    }, [paginationNoti.page, isLogin]);

    return (
        <header className={cx('wrapper')}>
            <div className={cx('top')}>
                <div className={cx('top-inner')}>
                    <div className={cx('info')}>
                        <div className={cx('item')}>
                            <img src={SVGS.IconTimer} alt="" />
                            <span>{listInfo[0]?.value}</span>
                        </div>
                        <div className={cx('item')}>
                            <img src={SVGS.IconPhone} alt="" />
                            <span>Hotline: {listInfo[1]?.value}</span>
                        </div>
                    </div>
                    {userInfo?.is_collab === true ? (
                        <div className={cx('ctv')}>
                            <span>Contributor</span>
                            <img src={SVGS.IconArrowRight} alt="" />
                        </div>
                    ) : userInfo?.is_collab === false ? (
                        <div className={cx('ctv')}>
                            <span>Member</span>
                            <img src={SVGS.IconArrowRight} alt="" />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            <div className={cx('bot')}>
                <div className={cx('bot-inner')}>
                    <div className={cx('logo')} onClick={() => navigate(config.routes.home)}>
                        <img src={IMAGES.NewLogo} alt="" />
                    </div>
                    <div className={cx('nav')}>
                        <div className={cx('navItems')}>
                            {navItems?.map((item, index) => {
                                return (
                                    <Fragment key={index}>
                                        <Link
                                            to={item.path}
                                            className={cx('item', {
                                                item_selected: item.path === location.pathname,
                                            })}
                                        >
                                            {item.title}
                                        </Link>

                                        {/* {item.id !== 4 ? (
                                            <Link
                                                to={item.path}
                                                className={cx('item', {
                                                    item_selected: item.path === location.pathname,
                                                })}
                                            >
                                                {item.title}
                                            </Link>
                                        ) : (
                                            <div
                                                className={cx('item', {
                                                    item_selected: item.path === location.pathname,
                                                })}
                                            >
                                                <a href={item.path} target="blank" className={cx('text')}>
                                                    {item.title}
                                                </a>
                                            </div>
                                        )} */}
                                    </Fragment>
                                );
                            })}
                        </div>
                        {/* <Row align="middle">
                            <div>
                                <img src={SVGS.IconSlideBar} alt="" />
                            </div>
                        </Row> */}
                        {/* <div className={cx('cart')}>
                            <img src={SVGS.IconCart} alt="" className={cx('cart')} onClick={handleClickCart} />
                            <div style={{ position: 'absolute', color: 'red' }}>2</div>
                        </div> */}
                        {isLogin && (
                            <Row align="middle">
                                <div className={cx('cart')}>
                                    <Badge
                                        count={countUnSeen}
                                        overflowCount={999}
                                        showZero
                                        className="mt-3"
                                        style={{
                                            backgroundColor: '#FBBC12',
                                            color: '#333',
                                            cursor: 'pointer',
                                            // marginRight: '20px',
                                        }}
                                    >
                                        <Popover
                                            placement="bottom"
                                            content={
                                                <Notification
                                                    countNoti={countNoti}
                                                    loading={loading}
                                                    notiList={notiList}
                                                    setNotiList={setNotiList}
                                                    fetchNotiList={fetchNotification}
                                                />
                                            }
                                            title={
                                                <Row style={{ padding: '10px' }} align="middle">
                                                    <Col span={12} style={{ fontSize: '22px', fontWeight: 'bold' }}>
                                                        Notification
                                                    </Col>
                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                        <Typography.Text
                                                            // strong
                                                            // underline
                                                            // italic
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={seenAllNoti}
                                                        >
                                                            Read them all
                                                        </Typography.Text>
                                                    </Col>
                                                </Row>
                                            }
                                            trigger="click"
                                            overlayClassName={'custom__tooltip'}
                                        >
                                            <BellOutlined style={{ fontSize: '24px' }} />
                                        </Popover>
                                    </Badge>
                                </div>
                            </Row>
                        )}
                        <Row align="middle">
                            <div className={cx('cart')}>
                                <Badge
                                    count={cartItemsCount}
                                    showZero
                                    overflowCount={99}
                                    className="mt-3"
                                    style={{
                                        backgroundColor: '#FBBC12',
                                        color: '#333',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <img src={SVGS.IconCart} alt="" onClick={handleClickCart} />
                                </Badge>
                            </div>
                        </Row>

                        <div className={cx('nav_desktop')}>
                            {isLogin ? (
                                <Popover
                                    placement="bottom"
                                    content={contentAccount}
                                    // trigger="click"
                                    overlayStyle={{
                                        width: '190px',
                                    }}
                                >
                                    <Row>
                                        <div className={cx('avatar')}>
                                            <img src={userInfo?.avatar || IMAGES.NewLogo} alt="" />
                                        </div>
                                        <div className={cx('name_section')}>
                                            <Row className={cx('hello')}>Hello,</Row>
                                            <Row className={cx('name')}>
                                                <>
                                                    {userInfo?.fullname || userInfo?.phone}
                                                    {userInfo?.is_collab ? (
                                                        <img
                                                            src={SVGS.IconChecked}
                                                            alt=""
                                                            style={{ marginLeft: '3px' }}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            </Row>
                                        </div>
                                    </Row>
                                </Popover>
                            ) : (
                                <div className={cx('login_button')} onClick={() => navigate(config.routes.login)}>
                                    LOG IN
                                </div>
                            )}
                        </div>
                        <div className={cx('nav_mobile')}>
                            {isLogin ? (
                                <Popover
                                    placement="bottomRight"
                                    content={contentAccount}
                                    trigger="click"
                                    overlayStyle={{
                                        width: '190px',
                                    }}
                                >
                                    <Row>
                                        <div className={cx('avatar')}>
                                            <img src={userInfo?.avatar || IMAGES.NewLogo} alt="" />
                                        </div>
                                    </Row>
                                </Popover>
                            ) : null}
                        </div>
                        <Row align="middle">
                            <div className={cx('navItems_mobile')}>
                                <Popover
                                    placement="bottomRight"
                                    content={contentNavbar}
                                    trigger="click"
                                    overlayStyle={{
                                        width: '130px',
                                    }}
                                >
                                    <Row>
                                        <img src={SVGS.IconSlideBar} alt="" />
                                    </Row>
                                </Popover>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
            {isShowLogoutModal && (
                <Modal
                    centered
                    visible={isShowLogoutModal}
                    onCancel={onCancel}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <LogOutModal onCancel={onCancel} onLogOut={onLogOut} />
                    </div>
                </Modal>
            )}
        </header>
    );
};

export default Header;
